import Reveal from '@/components/Reveal';
import { homeMock } from '@/mocks/home';

export default function Access() {
  const contacts = [
    { ...homeMock.access.contacts.phone, icon: 'ri-phone-line', className: 'md:col-span-4' },
    { ...homeMock.access.contacts.line, icon: 'ri-line-line', className: 'md:col-span-4' },
    { ...homeMock.access.contacts.instagram, icon: 'ri-instagram-line', className: 'md:col-span-4' },
  ];

  return (
    <section id="access" className="w-full bg-mahjong-cream py-32 md:py-40">
      <div className="px-6 md:px-10 lg:px-16">
        {/* CTA Text */}
        <Reveal className="mb-14 max-w-2xl md:mb-20" variant="fade-up">
          <h2 className="mb-5 whitespace-pre-line font-serif text-2xl font-bold leading-relaxed text-mahjong-dark md:text-4xl lg:text-5xl">
              {homeMock.access.title}
            </h2>
          <p className="max-w-xl font-sans text-sm text-mahjong-warm md:text-base">
              {homeMock.access.subtitle}
            </p>
        </Reveal>

        <div className="mb-20 grid grid-cols-1 gap-6 md:grid-cols-12 md:gap-7">
          {contacts.map((contact, index) => (
            <Reveal
              key={contact.label}
              delay={index * 120}
              className={contact.className}
            >
              <a
                href={contact.href}
                target={contact.href.startsWith('http') ? '_blank' : undefined}
                rel={contact.href.startsWith('http') ? 'noreferrer' : undefined}
                className="group flex flex-row items-center gap-5 rounded-2xl bg-mahjong-bg p-5 text-mahjong-dark transition-all duration-300 hover:-translate-y-2 hover:bg-mahjong-primary hover:text-white hover:shadow-2xl md:aspect-[4/5] md:min-h-[260px] md:flex-col md:items-stretch md:justify-between md:gap-0 md:p-7"
              >
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-current/20 md:h-20 md:w-20">
                  <i className={`${contact.icon} text-2xl transition-transform duration-300 group-hover:rotate-6 md:text-4xl`} />
                </div>
                <div>
                  <p className="mb-2 hidden font-sans text-xs uppercase tracking-[0.35em] opacity-60 md:block">
                    CONTACT
                  </p>
                  <h3 className="mb-1 font-serif text-xl font-bold md:mb-3 md:text-3xl">
                    {contact.label}
                  </h3>
                  <p className="font-sans text-sm opacity-75">
                    {contact.value}
                  </p>
                </div>
              </a>
            </Reveal>
          ))}
        </div>

        {/* Banner Image */}
        <Reveal className="mb-14 overflow-hidden rounded-2xl md:mb-20" variant="fade-up">
        <div className="h-[280px] md:h-[360px]">
          <img
            src={homeMock.access.image}
            alt="雀荘 和へのアクセス"
            className="h-full w-full object-cover object-top"
          />
        </div>
        </Reveal>

        {/* Access Info Grid */}
        <div className="grid grid-cols-1 gap-10 text-left md:grid-cols-3 md:gap-10">
          {/* Address */}
          <Reveal>
          <div className="flex flex-col items-start">
            <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-mahjong-primary/10">
              <i className="ri-map-pin-line text-mahjong-primary text-xl" />
            </div>
            <h3 className="mb-2 font-serif text-base font-bold text-mahjong-dark">
              住所
            </h3>
            <p className="font-sans text-sm leading-relaxed text-mahjong-dark/70">
              {homeMock.access.address}
            </p>
          </div>
          </Reveal>

          {/* Phone */}
          <Reveal delay={120}>
          <div className="flex flex-col items-start">
            <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-mahjong-primary/10">
              <i className="ri-phone-line text-mahjong-primary text-xl" />
            </div>
            <h3 className="mb-2 font-serif text-base font-bold text-mahjong-dark">
              電話番号
            </h3>
            <p className="font-sans text-sm text-mahjong-dark/70">
              {homeMock.access.phone}
            </p>
          </div>
          </Reveal>

          {/* Hours */}
          <Reveal delay={240}>
          <div className="flex flex-col items-start">
            <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-mahjong-primary/10">
              <i className="ri-time-line text-mahjong-primary text-xl" />
            </div>
            <h3 className="mb-2 font-serif text-base font-bold text-mahjong-dark">
              営業時間
            </h3>
            <div className="space-y-1">
              {homeMock.access.hours.map((h) => (
                <p key={h.day} className="font-sans text-sm text-mahjong-dark/70">
                  {h.day}: {h.time}
                </p>
              ))}
            </div>
          </div>
          </Reveal>
        </div>

        {/* Map Embed Placeholder */}
        <Reveal className="mt-16 overflow-hidden rounded-2xl bg-mahjong-card md:mt-24" variant="fade-up">
        <div className="h-[420px]">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.8278537074427!2d139.7016363152582!3d35.69384098019095!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188cd0d6b8c4c3%3A0x8c8e8c8c8c8c8c8c!2z5p2x5Lqs6YO95p2x5Lqs5Yy6!5e0!3m2!1sja!2sjp!4v1234567890"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="雀荘 和の地図"
          />
        </div>
        </Reveal>
      </div>
    </section>
  );
}